import React from 'react'

import Verified from "../../../../../assets/img/verificado.png"

const channelTitle = ({
    channelName,
}) => (
    <div className="player-title">
        <h4>{channelName}</h4>
        <img src={Verified} height={12} alt={channelName} />
    </div>
)

export default channelTitle
